import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimelineTag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 6,
	height: 8,
	viewBox: "0 0 6 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M-3.49691e-08 7.2C-2.53526e-08 7.42 0.0734372 7.60833 0.220312 7.765C0.367187 7.92167 0.54375 8 0.75 8L5.25 8C5.45625 8 5.63281 7.92167 5.77969 7.765C5.92656 7.60833 6 7.42 6 7.2L6 2.8C6 2.67333 5.97344 2.55333 5.92031 2.44C5.86719 2.32667 5.79375 2.23333 5.7 2.16L3 1.31134e-07L0.299999 2.16C0.206249 2.23333 0.132812 2.32667 0.0796869 2.44C0.026562 2.55333 -2.32836e-07 2.67333 -2.27299e-07 2.8L-3.49691e-08 7.2Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgTimelineTag);
export default ForwardRef;
